import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import emblem from "../images/emblem.png";
import angelo_sign from "../images/signature.png";
import background from "../images/background.jpg";
import ventraip_logo from "../images/ventraip-logo.png";
import zuver_logo from "../images/zuver-logo.svg";
import synergy_logo from "../images/synergy-logo.png";
import aussie_image from "../images/beni-steven.png";

const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" />
      <div className={`login-mobile clearfix`}>
          <div className={`container login-mobile__container clearfix`}>
              <span className={`login-mobile__text`}>Are you a Netorgin customer?</span>
              <a target={`_blank`} href={'https://clients.netorigin.com.au/clientarea.php'} className={`Login here`}>Login here</a>
          </div>
      </div>
      <div className={`looking clearfix`}>
          <div className={`looking__top clearfix`}>
              <div className={`looking__top-wrapper clearfix`}>
                  <div className={`looking__heading clearfix`}>NOT FOUND</div>
                  <div className={`looking__description clearfix`}>You just hit a route that doesn&#39;t exist... the sadness.</div>
              </div>
          </div>
          <div className={`looking__bottom clerfix`}>
              <div className={`looking__brands clearfix brands`}>
                  <div className={`brands__list clearfix`}>
                      <div className={`brands__item`}>
                          <div className={`brands-box brands-box--ventraip clearfix`}>
                              <div className={`brands-box__top clearfix`}>
                                  <a className={`logo brands-box__logo`}>
                                      <img src={ventraip_logo} alt={`VentraIP Australia`} className={`logo__image`}/>
                                  </a>
                                  <div className={`clear`} />
                                  <div className={`brands-box__for for for--ipad clearfix`}>
                                      <span className={`for__text clearfix`}>For</span>
                                  </div>
                                  <div className={`clear`} />
                                  <div className={`brands-box__heading brands-box__heading--ipad clearfix`}>Powerful cPanel Web Hosting</div>
                              </div>
                              <div className={`brands-box__bottom clearfix`}>
                                  <div className={`brands-box__wrapper clearfix`}>
                                      <div className={`brands-box__for for clearfix`}>
                                          <span className={`for__text clearfix`}>For</span>
                                      </div>
                                      <div className={`brands-box__heading clearfix`}>Powerful cPanel Web Hosting</div>
                                      <div className={`brands-box__description clearfix`}>Industry leading customer service delivered to you right here from Australia, 24x7, all year round.</div>
                                      <ul className={`brands-box__list clearfix`}>
                                          <li>
                                              <i className={`icon icon-tick-solid`}/>
                                              <span className={`text`}>
                                                  24/7 Australian Support
                                              </span>
                                          </li>
                                          <li>
                                              <i className={`icon icon-tick-solid`}/>
                                              <span className={`text`}>
                                                 99.9% Uptime Guarantee
                                              </span>
                                          </li>
                                          <li>
                                              <i className={`icon icon-tick-solid`}/>
                                              <span className={`text`}>
                                                 45 Day Money
                                              </span>
                                          </li>
                                          <li>
                                              <i className={`icon icon-tick-solid`}/>
                                              <span className={`text`}>
                                                  DDoS and Firewall Protection
                                              </span>
                                          </li>
                                      </ul>
                                      <a href={'https://ventraip.com.au/web-hosting/shared/'} target={'_blank'} className={`brands-box__button clearfix`}>Web Hosting Plans</a>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className={`brands__item`}>
                          <div className={`brands-box brands-box--zuver clearfix`}>
                              <div className={`brands-box__top clearfix`}>
                                  <a className={`logo brands-box__logo`}>
                                      <img src={zuver_logo} alt={`Zuver`} className={`logo__image`}/>
                                  </a>
                                  <div className={`brands-box__for for for--ipad clearfix`}>
                                      <span className={`for__text clearfix`}>For</span>
                                  </div>
                                  <div className={`clear`} />
                                  <div className={`brands-box__heading brands-box__heading--ipad clearfix`}>Powerful cPanel Web Hosting</div>
                              </div>
                              <div className={`brands-box__bottom clearfix`}>
                                  <div className={`brands-box__wrapper clearfix`}>
                                      <div className={`brands-box__for for clearfix`}>
                                          <span className={`for__text clearfix`}>For</span>
                                      </div>
                                      <div className={`brands-box__heading clearfix`}>Fast Smarter WordPress Hosting</div>
                                      <div className={`brands-box__description clearfix`}>Zuver's range of Smarter WordPress hosting plans deliver superior performance on Australia's fastest hosting platform.</div>
                                      <ul className={`brands-box__list clearfix`}>
                                          <li>
                                              <i className={`icon icon-tick-solid`}/>
                                              <span className={`text`}>
                                                  Built for WordPress
                                              </span>
                                          </li>
                                          <li>
                                              <i className={`icon icon-tick-solid`}/>
                                              <span className={`text`}>
                                                 Smart WordPress updates
                                              </span>
                                          </li>
                                          <li>
                                              <i className={`icon icon-tick-solid`}/>
                                              <span className={`text`}>
                                                 Lightning Fast SSD Storage
                                              </span>
                                          </li>
                                          <li>
                                              <i className={`icon icon-tick-solid`}/>
                                              <span className={`text`}>
                                                  Staging and Cloning of your WordPress site
                                              </span>
                                          </li>
                                      </ul>
                                      <a href={'https://zuver.net.au/wordpress-hosting/'} target={'_blank'} className={`brands-box__button clearfix`}>Managed Wordpress Plans</a>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className={`brands__item`}>
                          <div className={`brands-box brands-box--synergy clearfix`}>
                              <div className={`brands-box__top clearfix`}>
                                  <a className={`logo brands-box__logo`}>
                                      <img src={synergy_logo} alt={`Synergy Wholesale`} className={`logo__image`}/>
                                  </a>
                                  <div className={`brands-box__for for for--ipad clearfix`}>
                                      <span className={`for__text clearfix`}>For</span>
                                  </div>
                                  <div className={`clear`} />
                                  <div className={`brands-box__heading brands-box__heading--ipad clearfix`}>Powerful cPanel Web Hosting</div>
                              </div>
                              <div className={`brands-box__bottom clearfix`}>
                                  <div className={`brands-box__wrapper clearfix`}>
                                      <div className={`brands-box__for for clearfix`}>
                                          <span className={`for__text clearfix`}>For</span>
                                      </div>
                                      <div className={`brands-box__heading clearfix`}>Wholesale Whitelabel Reseller Hosting</div>
                                      <div className={`brands-box__description clearfix`}>Partner with Australia's favourite wholesale provider and enjoy cost-price services backed by our industry-leading service.</div>
                                      <ul className={`brands-box__list clearfix`}>
                                          <li>
                                              <i className={`icon icon-tick-solid`}/>
                                              <span className={`text`}>
                                                  Wholesale Pricing
                                              </span>
                                          </li>
                                          <li>
                                              <i className={`icon icon-tick-solid`}/>
                                              <span className={`text`}>
                                                 Whitelabel platform
                                              </span>
                                          </li>
                                          <li>
                                              <i className={`icon icon-tick-solid`}/>
                                              <span className={`text`}>
                                                 API Integration
                                              </span>
                                          </li>
                                          <li>
                                              <i className={`icon icon-tick-solid`}/>
                                              <span className={`text`}>
                                                  Powerful Portfolio Management
                                              </span>
                                          </li>
                                      </ul>
                                      <a href={'https://synergywholesale.com/'} target={'_blank'} className={`brands-box__button clearfix`}>Reseller Hosting</a>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div className={`form clearfix`}>
          <div className={`form__wrapper clearfix container`}>
              <div className={`form__box clearfix form-box`}>
                  <div className={`form-box__left`}>
                      <div className={`form-box__heading clearfix`}>Australian & Global Domain Names</div>
                  </div>
                  <div className={`form-box__right`}>
                      <form name={`domainForm`} action={`https://secure.ventraip.com.au/domainchecker.php`} method={`post`} className={`form-box__form clearfix`}>
                          <input name={`domain`} placeholder={`Search your search here!`} type={`text`} className={`form-box__textfield`} />
                          <input name={`direct`} value="true" type="hidden" />
                          <button className={`form-box__button`}><i className={`icon icon-search`} /></button>
                      </form>
                  </div>
              </div>
          </div>
      </div>
      <div className={`aussie clearfix`}>
          <div className={`aussie__wrapper container clearfix`}>
              <div className={`aussie__left clearfix`}>
                  <div className={`aussie__heading`}>100% Aussie. 100% Local.</div>
                  <div className={`aussie__description`}>
                      <p>Unlike the big corporations who treat you like a number on their spreadsheet, we believe a happy customer is the key to providing Australia’s #1 hosting service.</p>
                      <p>That’s why our team are there for you when you need them most. 24 hours a day, 7 days per week via email, eTicket, Live Chat, and phones… and best of all? They’re all 100% local so you know they speak your language!</p>
                  </div>
              </div>
              <img className={`aussie__image`} src={aussie_image} alt={`100% Aussie. 100% Local.`} />
          </div>
      </div>
      <div className={`clear`} />
      <div className={`faq clearfix`}>
          <div className={`faq__wrapper clearfix container`}>
              <div className={`faq__heading`}>Common questions you might have</div>
              <div className={`faq__list clearfix`}>
                  <div className={`faq__item faq-item clearfix`}>
                      <div className={`faq-item__heading`}>
                          <div className={`faq-item__heading-text`}>Are there any lock-in contracts?</div>
                          <div className={`faq-item__arrow-wrapper clearfix`}>
                              <i className={`icon icon-arrow`} />
                          </div>
                      </div>
                      <div className={`faq-item__description`}>We don’t believe in lock-in contracts! You’ll never find any here at VentraIP Australia and can always refund any unused time if you decide to prepay for your service.</div>
                  </div>
                  <div className={`faq__item faq-item clearfix`}>
                      <div className={`faq-item__heading`}>
                          <div className={`faq-item__heading-text`}>Can you set up my Virtual Private Server for me?</div>
                          <div className={`faq-item__arrow-wrapper clearfix`}>
                              <i className={`icon icon-arrow`} />
                          </div>
                      </div>
                      <div className={`faq-item__description`}>We don’t believe in lock-in contracts! You’ll never find any here at VentraIP Australia and can always refund any unused time if you decide to prepay for your service.</div>
                  </div>
                  <div className={`faq__item faq-item clearfix`}>
                      <div className={`faq-item__heading`}>
                          <div className={`faq-item__heading-text`}>Why is Windows Server not an option for my OS?</div>
                          <div className={`faq-item__arrow-wrapper clearfix`}>
                              <i className={`icon icon-arrow`} />
                          </div>
                      </div>
                      <div className={`faq-item__description`}>We don’t believe in lock-in contracts! You’ll never find any here at VentraIP Australia and can always refund any unused time if you decide to prepay for your service.</div>
                  </div>
                  <div className={`faq__item faq-item clearfix`}>
                      <div className={`faq-item__heading`}>
                          <div className={`faq-item__heading-text`}>Where is my Virtual Private Server located?</div>
                          <div className={`faq-item__arrow-wrapper clearfix`}>
                              <i className={`icon icon-arrow`} />
                          </div>
                      </div>
                      <div className={`faq-item__description`}>We don’t believe in lock-in contracts! You’ll never find any here at VentraIP Australia and can always refund any unused time if you decide to prepay for your service.</div>
                  </div>
              </div>
          </div>
      </div>
      <div className={`customer clearfix`}>
          <div className={`customer__wrapper clearfix container`}>
              <div className={`customer__left clearfix`}>
                  <div className={`customer__heading clearfix`}>Are you a Netorigin customer?</div>
                  <div className={`customer__description clearfix`}>You can still log into your Netorigin portal and manage your services.</div>
              </div>
              <div className={`customer__right clearfix`}>
                  <a className={`customer__button clearfix`} target={`_blank`} href={'https://clients.netorigin.com.au/clientarea.php'}>Login to Netorigin</a>
              </div>
          </div>
      </div>
  </Layout>
)

export default NotFoundPage
